import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule, CurrencyPipe, DecimalPipe } from '@angular/common';
import { SettingsComponent } from './components/settings/settings.component';
import { SettingsRoutingModule } from './settings.routing.module';
import { KpiConfigComponent } from './components/kpi-config/kpi-config.component';
import { HierarchySetupComponent } from './components/hierarchy-setup/hierarchy-setup.component';
import { HierarchyTileComponent } from './components/hierarchy-setup/hierarchy-tile/hierarchy-tile.component';
import { TileConnectorComponent } from './components/hierarchy-setup/tile-connector/tile-connector.component';
import { SharedModule } from '../shared/shared.module';
import { ThirdPartyModule } from '../third-party/third-party.module';
import { ReactiveFormsModule } from '@angular/forms';
import { UserManagementComponent } from './components/user-management/user-management.component';
import { MilestonesEventsComponent } from './components/milestones-events/milestones-events.component';

// Integration
import { IntegrationComponent } from './components/integration-setup/integration-setup.component';
import { FileUploadIntegrationComponent } from './components/integration-setup/file-upload-integration/file-upload-integration.component';
import { HolidayHoursComponent } from './components/integration-setup/holiday-hours/holiday-hours.component';
import { DeleteLoanComponent } from './components/integration-setup/delete-loan/delete-loan.component';

// Profile
import { ProfileAccountDetailsComponent } from './components/profile/account-details/account-details.component';
import { ProfileNotificationsComponent } from './components/profile/notifications/notifications.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { CompanyAccountDetailsComponent } from './components/company-account-details/company-account-details.component';
import { ClientContactsService } from './services/client-contacts.service';
import { ClientEditScreenComponent } from './components/client-edit-screen/client-edit-screen.component';
import { PowerEmployeeDialogComponent } from './components/company-account-details/power-employee-dialog/power-employee-dialog.component';

// LBA
import { ApplicationModuleService } from './services/application-module.service';
import { HierarchyConfigComponent } from './components/hierarchy-config/hierarchy-config.component';
import { DatePipe } from '@angular/common';
import { LbaSubscriptionsComponent } from './components/lba-subscriptions/lba-subscriptions.component';
import { ClientSubscriptionService } from './services/client-subscription.service';
import { ClientSubscriptionPageComponent } from './components/lba-shared/client-subscription-page/client-subscription-page.component';
import { EmployeeComponent } from './components/employee/employee.component';
import { RoleManagementComponent } from './components/role-management/role-management.component';
import { EmployeePositionService } from './services/employee-position.service';
import { PermissionSetManagementComponent } from './components/role-management/permission-set-management/permission-set-management.component';
import { UserPermissionsService } from './services/user-permissions.service';
import { PermissionSetPagesComponent } from './components/role-management/permission-set-pages/permission-set-pages.component';
import { BranchProjectionsConfigComponent } from './components/branch-projections-config/branch-projections-config.component';
import { LBASuperUserService } from './services/lba-super-user.service';
import { LbaUsersComponent } from './components/lba-users/lba-users.component';
import { LbaClientsComponent } from './components/lba-clients/lba-clients.component';
import { ClientProductMappingComponent } from './components/client-product-mapping/client-product-mapping.component';
import { LbaLoginActivityComponent } from './components/lba-login-activity/lba-login-activity.component';
import { IntlModule } from '@progress/kendo-angular-intl';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { KpiScorecardComponent } from './components/kpi-scorecard/kpi-scorecard.component';
import { UserExtendedAccessService } from './services/user-extended-access.service';
import { UserExtendedAccessMenuComponent } from './components/user-management/user-extended-access-menu/user-extended-access-menu.component';
import { DomainManagementComponent } from './components/domains/domain-management/domain-management.component';
import { ConfirmationAlertDialogComponent } from './components/confirmation-alert-dialog/confirmation-alert-dialog.component';
import { UploadModule } from '@progress/kendo-angular-upload';
import { CompanyNotificationsComponent } from './components/company-notifications/company-notifications.component';
import { NgxMaskModule } from 'ngx-mask';
import { ScheduledReportsComponent } from './components/scheduled-reports/scheduled-reports.component';
import { LoanCharacteristicsMappingComponent } from './components/loan-characteristics-mapping/loan-characteristics-mapping.component';
import { ClientLookupService } from './services/client-lookup.service';
import { ClientEditContactsComponent } from './components/client-edit-screen/form-groups/client-edit-contacts/client-edit-contacts.component';
import { ClientEditDetailsComponent } from './components/client-edit-screen/form-groups/client-edit-details/client-edit-details.component';
import { ClientEditIdentitiesComponent } from './components/client-edit-screen/form-groups/client-edit-identities/client-edit-identities.component';
import { ClientEditIntegrationsComponent } from './components/client-edit-screen/form-groups/client-edit-integrations/client-edit-integrations.component';
import { GeneralLedgerMappingComponent } from './components/general-ledger-mapping/general-ledger-mapping.component';
import { ClientHealthComponent } from './components/client-health/client-health.component';
import { KPIConfigService } from 'app/modules/settings/services/kpi-config.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { KpiConfigOneComponent } from 'app/modules/settings/components/kpi-config/kpi-config-one/kpi-config-one.component';
import { KpiConfigThreeComponent } from './components/kpi-config/kpi-config-three/kpi-config-three.component';
import { KpiConfigFourComponent } from './components/kpi-config/kpi-config-four/kpi-config-four.component';
import { PermissionSetUsersComponent } from './components/role-management/permission-set-users/permission-set-users.component';
import { MatTabsModule } from '@angular/material/tabs';
import { SubscriptionsComponent } from './components/subscriptions/subscriptions.component';
import { UserSubscriptionsComponent } from './components/user-subscriptions/user-subscriptions.component';
import { ECloseRoiSettingsComponent } from './components/e-close-roi-settings/e-close-roi-settings.component';
import { DistributionAnalyzeDialogComponent } from './components/kpi-distribution-analyze-dialog/distribution-analyze-dialog.component';
import { KpiVersionDialogComponent } from './components/kpi-config/kpi-version-dialog/kpi-version-dialog.component';
import { InvoicedLoansComponent } from './components/invoiced-loans/invoiced-loans.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { ClientIntegrationService } from './services/client-integration.service';
import { ClientDomainService } from './services/client-domain.service';
import { ClientProductService } from './services/client-product.service';
import { CsvUploadService } from './services/csv-upload.service';
import { FilterSetupService } from './services/filter-setup.service';
import { GeneralLedgerService } from './services/general-ledger.service';
import { HierarchyService } from './services/hierarchy.service';
import { HolidayService } from './services/holiday.service';
import { IntegrationSourceService } from './services/integration-source.service';
import { KpiScorecardService } from './services/kpi-scorecard.service';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { EmployeeHoursComponent } from './components/employee-hours/employee-hours.component';

@NgModule({
    declarations: [
        SettingsComponent,
        KpiConfigComponent,
        HierarchySetupComponent,
        ConfirmationAlertDialogComponent,
        HierarchyTileComponent,
        TileConnectorComponent,
        UserManagementComponent,
        ProfileAccountDetailsComponent,
        ProfileNotificationsComponent,
        ChangePasswordComponent,
        HierarchyConfigComponent,
        LbaSubscriptionsComponent,
        ClientSubscriptionPageComponent,
        EmployeeComponent,
        RoleManagementComponent,
        PermissionSetManagementComponent,
        PermissionSetPagesComponent,
        BranchProjectionsConfigComponent,
        IntegrationComponent,
        FileUploadIntegrationComponent,
        HolidayHoursComponent,
        DeleteLoanComponent,
        LbaUsersComponent,
        LbaClientsComponent,
        ClientProductMappingComponent,
        MilestonesEventsComponent,
        LbaLoginActivityComponent,
        CompanyAccountDetailsComponent,
        CompanyAccountDetailsComponent,
        ClientEditScreenComponent,
        KpiScorecardComponent,
        UserExtendedAccessMenuComponent,
        DomainManagementComponent,
        UserExtendedAccessMenuComponent,
        PowerEmployeeDialogComponent,
        CompanyNotificationsComponent,
        ScheduledReportsComponent,
        LoanCharacteristicsMappingComponent,
        ClientEditContactsComponent,
        ClientEditDetailsComponent,
        ClientEditIdentitiesComponent,
        ClientEditIntegrationsComponent,
        GeneralLedgerMappingComponent,
        ClientHealthComponent,
        KpiConfigOneComponent,
        KpiConfigThreeComponent,
        KpiConfigFourComponent,
        PermissionSetUsersComponent,
        SubscriptionsComponent,
        UserSubscriptionsComponent,
        ECloseRoiSettingsComponent,
        DistributionAnalyzeDialogComponent,
        KpiVersionDialogComponent,
        InvoicedLoansComponent,
    ],
    imports: [
        CommonModule,
        SettingsRoutingModule,
        SharedModule,
        ReactiveFormsModule,
        MatTabsModule,
        IntlModule,
        DateInputsModule,
        UploadModule,
        NgxMaskModule.forRoot(),
        MatProgressBarModule,
        MatTooltipModule,
        GridModule,
        ThirdPartyModule,
        GridModule,
        MatCardModule,
        MatIconModule,
    ],
    providers: [
        DatePipe,
        ApplicationModuleService,
        ClientIntegrationService,
        ClientDomainService,
        ClientProductService,
        CsvUploadService,
        FilterSetupService,
        GeneralLedgerService,
        HierarchyService,
        HolidayService,
        IntegrationSourceService,
        KPIConfigService,
        KpiScorecardService,
        LBASuperUserService,
        ClientSubscriptionService,
        EmployeePositionService,
        UserPermissionsService,
        ClientContactsService,
        CurrencyPipe,
        DecimalPipe,
        UserExtendedAccessService,
        ClientLookupService,
    ],
    schemas: [NO_ERRORS_SCHEMA],
})
export class SettingsModule {}
